(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('TestDialogController', TestDialogController);

    TestDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Test', 'BatteryTest', 'Section'];

    function TestDialogController ($scope, $stateParams, $uibModalInstance, entity, Test, BatteryTest, Section) {
        var vm = this;
        vm.test = entity;
        vm.batterytests = BatteryTest.query();
        vm.sections = Section.query();
        vm.load = function(id) {
            Test.get({id : id}, function(result) {
                vm.test = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:testUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.test.id !== null) {
                Test.update(vm.test, onSaveSuccess, onSaveError);
            } else {
                Test.save(vm.test, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
